import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Pager from './Pager';

export default class ListPager extends Component {
    static propTypes = {
        listChunk: PropTypes.object,
        onChangeOffset: PropTypes.func.isRequired
    };

    render() {
        const {listChunk} = this.props;

        if (!listChunk)
            return null;

        const {offset, limit, totalCount} = listChunk;
        const pageCount = Math.ceil(totalCount / limit);
        const currentPage = 1 + Math.floor(offset / limit);

        return (
            <Pager currentPage={currentPage}
                   pageCount={pageCount}
                   onChange={this.handleChangePage}/>
        );
    }

    handleChangePage = page => {
        const {listChunk: {limit}} = this.props;
        const nextOffset = (page - 1) * limit;

        this.props.onChangeOffset(nextOffset);
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/ListPager.jsx